import { render, staticRenderFns } from "./RegisterLogout.vue?vue&type=template&id=3907e729"
import script from "./RegisterLogout.vue?vue&type=script&lang=js"
export * from "./RegisterLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports